"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = exports.translateItemsToOptions = exports.usePStateful = exports.translateItemToOption = exports.valueProp = exports.generateNavTreePropType = exports.navTreePropType = exports.getClickableA11yProps = exports.makeRenderWithClassName = exports.defaultRender = exports.getIcon = exports.getIconClassName = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

require("../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = require("underscore");

var _KeyboardUtils = require("./KeyboardUtils");

var _Icon = _interopRequireDefault(require("../components/general/Icon"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source))).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

/**
 * @module util/PropUtils
 * @desc The module contains common utility functions for use with props and prop names
 */

/**
 * @alias module:util/PropUtils.getIconClassName
 *
 * @desc Given an object of props that may contain 'iconClassName', 'iconName', or
 *    'icon', returns a class name for the right icon
 *
 * @param {object} props
 *    The props.
 * @returns {string}
 *    The className to get the correct CSS
 *
 * @example
 *   getIconClassName({iconName: 'globe'})
 *   // 'icon-globe'
 * @example
 *   getIconClassName({iconClassName: 'globe-icon'})
 *   // 'icon-globe'
 */
var getIconClassName = function getIconClassName(props) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var icon = props.iconClassName || props.iconName || props.icon || options.useId && props.id;

  if (!icon || typeof icon !== "string") {
    return null;
  }

  if (props.iconClassName) {
    return icon;
  }

  return "icon-".concat(icon);
};

exports.getIconClassName = getIconClassName;

var getIcon = function getIcon(icon, props) {
  if (typeof icon === "string") {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
      iconName: icon
    }, props));
  } else {
    return icon;
  }
};
/**
 * @alias module:util/PropUtils.defaultRender
 *
 * @desc This can be the default value for any simple render function.
 *    It will simply pass the props to the default component
 *
 * @param {object} props
 *    The props.
 * @param {object} DefaultComponent
 *    The default component that is rendered unless this function is overridden.
 * @returns {node}
 *    A rendered node.
 *
 */


exports.getIcon = getIcon;

var defaultRender = function defaultRender(props, DefaultComponent) {
  return /*#__PURE__*/_react.default.createElement(DefaultComponent, props);
};
/**
 * @alias module:util/PropUtils.makeRenderWithClassName
 *
 * @desc Returns render function that inserts a new className into the props
 *
 * @param {string} className
 */


exports.defaultRender = defaultRender;

var makeRenderWithClassName = function makeRenderWithClassName(className) {
  return function (props, DefaultComponent) {
    return defaultRender(_objectSpread(_objectSpread({}, props), {}, {
      className: (0, _classnames.default)(props.className, className)
    }), DefaultComponent);
  };
};
/**
 * @alias module:util/PropUtils.getClickableA11yProps
 *
 * @desc Gets an object of props that make an element that's not normally clickable
 *       act like an HTML <button />.
 *
 * @param {function} onClick
 *    The onClick function that gets called when the component is clicked; call on enter and on space.
 * @returns {object}
 *    Returns a spreadable props object with an onKeyDown function, an aria role and a tabIndex.
 *
 */


exports.makeRenderWithClassName = makeRenderWithClassName;

var getClickableA11yProps = function getClickableA11yProps() {
  var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return {
    onKeyDown: function onKeyDown(e) {
      if ((0, _KeyboardUtils.isEnter)(e.keyCode) || (0, _KeyboardUtils.isSpace)(e.keyCode)) {
        e.preventDefault();
        onClick(e);
      }
    },
    role: "button",
    tabIndex: 0
  };
};

exports.getClickableA11yProps = getClickableA11yProps;
var navProps = {
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  label: _propTypes.default.string
};

var navTreePropType = _propTypes.default.arrayOf(_propTypes.default.shape(navProps));
/**
 * @alias module:util/PropUtils.generateNavTreePropType
 *
 * @desc Creates a propType for a navTree with a given number of levels, along with optional extra
 * props.
 *
 * @param {int} levels
 *    The number of levels that the tree should have.
 * @param {Object[]}
 *    An array of extra prop objects added to the level corresponding to their position in array.
 *    For example, passing [null, { icon: PropTypes.string }] would give the second level of the
 *    tree an icon prop.
 * @returns {function}
 *    Returns a propType that can be used to validate a nav tree.
 *
 */


exports.navTreePropType = navTreePropType;

var generateNavTreePropType = function generateNavTreePropType(levels) {
  var _context, _context2;

  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _reduce.default)(_context = (0, _fill.default)(_context2 = new Array(levels)).call(_context2, undefined) // Create each level in reverse order, starting with the lowest level of the tree.
  ).call(_context, function (childPropType, _, idx) {
    return (// Just use the starting accumulator if it's the lowest level of the tree,
      // since that won't have children.
      idx === 0 ? childPropType : _propTypes.default.arrayOf(_propTypes.default.shape(_objectSpread(_objectSpread({}, navProps), {}, {
        children: childPropType
      }, (0, _underscore.isObject)(extraProps[levels - idx - 1]) ? extraProps[levels - idx - 1] : {})))
    );
  }, navTreePropType);
};
/**
 * @alias module:util/PropUtils.valueProp
 *
 * @desc A prop type for any values that can be numbers or strings
 */


exports.generateNavTreePropType = generateNavTreePropType;

var valueProp = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
/**
 * @alias module:util/PropUtils.translateItemToOption
 *
 * @desc Turns object with id and name into object with value and label
 */


exports.valueProp = valueProp;

var translateItemToOption = function translateItemToOption(_ref) {
  var id = _ref.id,
      name = _ref.name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? id : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? name : _ref$label,
      helpHintText = _ref.helpHintText,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? helpHintText : _ref$hint,
      item = (0, _objectWithoutProperties2.default)(_ref, ["id", "name", "value", "label", "helpHintText", "hint"]);
  return _objectSpread(_objectSpread({}, item), {}, {
    hint: hint,
    value: value,
    label: label,
    id: value,
    name: label
  });
};
/**
 * @alias module:util/PropUtils.usePStateful
 *
 * @desc A progressive state hook.
 */


exports.translateItemToOption = translateItemToOption;

var usePStateful = function usePStateful(propValue, initial) {
  if (propValue === undefined) {
    return (0, _react.useState)(initial);
  } else {
    return [propValue, function () {}];
  }
};
/**
 * @alias module:util/PropUtils.translateItemsToOptions
 *
 * @desc Turns objects with ids and names into objects with values and labels
 */


exports.usePStateful = usePStateful;

var translateItemsToOptions = function translateItemsToOptions(items) {
  return (0, _map.default)(items).call(items, translateItemToOption);
};

exports.translateItemsToOptions = translateItemsToOptions;
var _default = {
  getIconClassName: getIconClassName,
  defaultRender: defaultRender
};
exports.default = _default;